// extracted by mini-css-extract-plugin
export var attachment = "_kk-a";
export var emailContainer = "_kk-4";
export var emailContentPaddedContainer = "_kk-b";
export var emailHeader = "_kk-6";
export var emailIframe = "_kk-3";
export var emailInfoIcon = "_kk-9";
export var emailShortenedSummary = "_kk-e";
export var infoDropdown = "_kk-0";
export var infoRowBoundedContent = "_kk-d";
export var internal = "_kk-5";
export var merchant = "_kk-8";
export var messageInputContainer = "_kk-h";
export var normal = "_kk-7";
export var replyCard = "_kk-f";
export var subtleButton = "_kk-1";
export var subtleButtonIconContainer = "_kk-2";
export var toggleViewRepliesButton = "_kk-c";
export var wrappingText = "_kk-g";